import type { Archive } from '../../api/archives';
import { clipDuration } from '../../format/helpers';
import type { AudioClip, VideoClip } from '../../format/types';
import { findClip, useTimeline } from '../../state/timeline';
import AudioClipInspector from './AudioClipInspector';
import ProjectSettings from './ProjectSettings';
import TextClipInspector from './TextClipInspector';
import VideoClipInspector from './VideoClipInspector';
import '../Inspector.css';

export default function Inspector({
  archives,
  onSeek,
}: {
  archives: Archive[];
  onSeek?: (t: number) => void;
}) {
  const edit = useTimeline((s) => s.edit);
  const selection = useTimeline((s) => s.selection);

  const loc = selection.length === 1 ? findClip(edit, selection[0]) : null;

  return (
    <div className="inspector">
      {!loc && selection.length === 0 && <ProjectSettings />}
      {!loc && selection.length > 1 && (
        <div className="insp-section">
          <h3>{selection.length} clips selected</h3>
          <p className="insp-hint">Select a single clip to edit its properties.</p>
        </div>
      )}
      {loc && loc.track.kind === 'video' && (
        <VideoClipInspector
          clip={loc.clip as VideoClip}
          track={loc.track}
          archives={archives}
          onSeek={onSeek}
        />
      )}
      {loc && loc.track.kind === 'overlay' && 'kind' in loc.clip && loc.clip.kind === 'text' && (
        <TextClipInspector clip={loc.clip} onSeek={onSeek} />
      )}
      {loc && loc.track.kind === 'overlay' && 'kind' in loc.clip && loc.clip.kind === 'image' && (
        <div className="insp-section">
          <h3>Image overlay</h3>
          <p className="insp-hint">duration {clipDuration(loc.clip).toFixed(1)}s</p>
        </div>
      )}
      {loc && loc.track.kind === 'audio' && <AudioClipInspector clip={loc.clip as AudioClip} />}
    </div>
  );
}
